import { FC } from 'react';

import { useFeatureIsOn } from '@growthbook/growthbook-react';
import ProductV1 from './containers/Product';
import { ProductDetailV2 } from './v2';

type ProductVersionProps = {
  id: string;
  language: string;
};

export const ProductVersion: FC<ProductVersionProps> = (props) => {
  const isV2 = useFeatureIsOn('feature.ecom2');
  if (isV2) return <ProductDetailV2 {...props} />;
  return <ProductV1 {...props} />;
};
